import { combineReducers, Reducer } from "redux";
import { FormStateMap, reducer as formReducer } from "redux-form";
import { connectRouter } from "connected-react-router";
import { History } from "history";
import { MiniMessageBox, Authnz, PageAlert } from "capitalrx-components";
import claimSearch, { ClaimSearchState } from "./appReducers/claims/search";
import memberInformation, { MemberInformationState } from "./appReducers/members/information";
import memberSearch, { MemberSearchState } from "./appReducers/members/search";
import planBenefitSearch, { PlanBenefitSearchState } from "./appReducers/planBenefits/search";
import planSearch, { PlanSearchState } from "./appReducers/plans/search";
import groupGet, { GroupGetState } from "./appReducers/groups/get";
import planGet, { PlanGetState } from "./appReducers/plans/get";
import planAccount, { GetPlanAccountState } from "./appReducers/planAccount/get";
import pharmacySearch, { PharmacySearchState } from "./appReducers/pharmacy/search";
import pricingLevelsList, { PricingLevelsListState } from "./appReducers/pricingLevels/list";
import pricingLevelsGet, { PricingLevelGetState } from "./appReducers/pricingLevels/get";
import pharmacyGet, { PharmacyGetState } from "./appReducers/pharmacy/get";
import batchTestClaim, { BatchTestClaimState } from "./appReducers/transmissions/batchTest/get";
import batchTestClaimList, { BatchTestClaimListState } from "./appReducers/transmissions/batchTest/list";
import batchManualClaim, { BatchManualClaimState } from "./appReducers/transmissions/batchManual/get";
import batchManualClaimList, { BatchManualClaimListState } from "./appReducers/transmissions/batchManual/list";
import transmissionTest, { TransmissionTestState } from "./appReducers/transmissions/testTransmission";
import transmissionManual, { TransmissionManualState } from "./appReducers/transmissions/manualTransmission";
import userPermissionsGet, { UserPermissionsGetState } from "./appReducers/userPermissions/get";
import drug, { DrugState } from "./appReducers/drug/drug";
import productListGet, { ProductListGetState } from "./appReducers/productLists/get";
import migrate, { MigrateState } from "./appReducers/migrate/migrate";
import { PageAlertState } from "../../types/appTypes/general";

interface AuthnzState {
  forgotPassword: {
    formSubmitSuccess: boolean;
  };
}

interface MiniMessageBoxState {
  show: boolean;
  type: string;
  message: string;
}

export interface RootState {
  form: FormStateMap;
  authnz: AuthnzState;
  pageAlert: PageAlertState;
  miniMessageBox: MiniMessageBoxState;
  claimSearch: ClaimSearchState;
  memberInformation: MemberInformationState;
  memberSearch: MemberSearchState;
  planBenefitSearch: PlanBenefitSearchState;
  planSearch: PlanSearchState;
  groupGet: GroupGetState;
  pharmacyGet: PharmacyGetState;
  planGet: PlanGetState;
  planAccount: GetPlanAccountState;
  pharmacySearch: PharmacySearchState;
  pricingLevelsList: PricingLevelsListState;
  pricingLevelsGet: PricingLevelGetState;
  batchTestClaim: BatchTestClaimState;
  batchTestClaimList: BatchTestClaimListState;
  batchManualClaim: BatchManualClaimState;
  batchManualClaimList: BatchManualClaimListState;
  transmissionTest: TransmissionTestState;
  transmissionManual: TransmissionManualState;
  userPermissionsGet: UserPermissionsGetState;
  drug: DrugState;
  productListGet: ProductListGetState;
  migrate: MigrateState;
}

export default (history: History): Reducer =>
  combineReducers({
    form: formReducer,
    authnz: Authnz.authnzReducer,
    router: connectRouter(history),
    miniMessageBox: MiniMessageBox.miniMessageBoxReducer,
    pageAlert: PageAlert.pageAlertReducer,
    claimSearch,
    memberInformation,
    memberSearch,
    planBenefitSearch,
    planSearch,
    groupGet,
    planGet,
    planAccount,
    pharmacySearch,
    pricingLevelsList,
    pricingLevelsGet,
    pharmacyGet,
    batchTestClaim,
    batchTestClaimList,
    batchManualClaim,
    batchManualClaimList,
    transmissionTest,
    transmissionManual,
    userPermissionsGet,
    drug,
    productListGet,
    migrate,
  });
